import { FAILURE, IDLE, REQUEST, SUCCESS } from 'src/redux/constants';
import { ADD_MODELS } from './constants';
import { ThunkAction } from 'redux-thunk';
import { State } from 'src/redux/reducer';
import { AddModelsDataActionTypes, IAddModels } from './types';
import modelsApi from 'src/utils/api/modelsApi';

export const loadAddModels =
  (
    addModels: IAddModels,
  ): ThunkAction<Promise<void>, State, null, AddModelsDataActionTypes> =>
  async (dispatch) => {
    dispatch({ type: ADD_MODELS + REQUEST });
    try {
      const payload = await modelsApi.loadAddModels(addModels);
      dispatch({ type: ADD_MODELS + SUCCESS, payload });
    } catch (error) {
      dispatch({ type: ADD_MODELS + FAILURE, error });
    }
  };

export const addModelsIdle = () => ({ type: ADD_MODELS + IDLE });
